$('.block-image-slider').each((index, element) => {
	const $slider = $(element).find('.image-slider__main');
	const $nav = $(element).find('.image-slider__nav');

	$slider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		asNavFor: $nav,
		arrows: false,
	});

	$nav.slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: $slider,
		dots: false,
		focusOnSelect: true,
		infinite: false,
		nextArrow: Globals.sliders.nextArrow,
		prevArrow: Globals.sliders.prevArrow,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

});
